import { Link } from "react-router";

import type { SessionWorkspace } from "@/lib/api/sessionPortal";

import { ALL_SESSIONS_COPY } from "./boxes/session-copy";

const KINDS = ["reinstate", "move", "cancel"] as const;

/**
 * The session's own changes, which open in its row of All sessions (O1, K3):
 * page navigation to that row's Move, Cancel or Reinstate, or a cancelled
 * session's Move plan, never a sheet here.
 */
export function SessionChangeLinks({ workspace, allSessionsPath }: { workspace: SessionWorkspace; allSessionsPath: string }) {
  const allowed = workspace.viewer.allowed_actions;
  const movePlan = workspace.session.status === "cancelled" && Boolean(workspace.plan.unit) && workspace.course.term_open && allowed.includes("edit_session_plan");
  const kinds = [...KINDS.filter((kind) => allowed.includes(`${kind}_session`)), ...(movePlan ? ["plan" as const] : [])];
  if (!kinds.length) return null;
  return (
    <nav aria-label="Change this session" data-session-change-links className="flex flex-wrap items-center gap-x-4 gap-y-1">
      {kinds.map((kind) => (
        <Link key={kind} to={`${allSessionsPath}&change=${kind}`} className="inline-flex min-h-11 items-center text-ui text-primary underline-offset-4 hover:underline">
          {kind === "plan" ? ALL_SESSIONS_COPY.movePlan : ALL_SESSIONS_COPY.change.verb[kind]}
        </Link>
      ))}
    </nav>
  );
}
